import React, {} from "react"
import '../../../css/InfluencerUpload.css'

export default function make_multi_content_grid_div(influencer_content, page = 'home', n_col = 3) {
   var influencer_content_rows = []
   if (page == 'home') {
      var content_array_name = 'content_list'
      var data_func = this.get_and_post_data_skeleton
   } else if (page == 'influencer') {
      var content_array_name = 'influencer_content'
      var data_func = this.get_and_post_data_skeleton
   }
   // }
   for (let i = 0; i < influencer_content.length; i += n_col) {
      if ((i + n_col) > influencer_content.length) {
         influencer_content_rows.push(influencer_content.slice(i, i + influencer_content.length))
      } else {
         influencer_content_rows.push(influencer_content.slice(i, i + n_col))
      }
   }
   return influencer_content_rows.map(
      (content_row, row_index) => {
         var single_influencer_row = this.make_single_influencer_row(content_row, content_array_name, data_func, n_col);
         var grid_row_class = 'grid_row_' + page;
         var grid_row2_class = 'grid_row2_' + page;
         return (
            <div className={grid_row_class}>
               <div className={grid_row2_class}>
                  {single_influencer_row}
               </div>
            </div>
         )
      }
   )
}
